/**
 * NewPipelineModal — public entry point for the "+ New pipeline" creation
 * dialog (SE-5487).
 *
 * A template picker (New Player Acquisitions / Academy Promotions / Outgoing
 * Transfers / Custom-blank) plus a name field in ONE dialog. On Create the
 * parent fires a single `CreateKanbanBoard` mutation (the BE seeds the stages);
 * CUSTOM opens the Stage Editor.
 *
 * Fresh selection/name state per open is achieved by the consumer keying the
 * element on its open state (`key={isOpen ? "open" : "closed"}` in
 * `usePipelineCreationFlow`) — the repo's sanctioned alternative to a
 * set-state-in-effect reset.
 * @module features/player-kanban/components/organisms/NewPipelineModal
 */

export { default } from "./NewPipelineModalContainer";
export type { NewPipelineModalContainerProps as NewPipelineModalProps } from "./NewPipelineModalContainer";
